module.exports = __webpack_public_path__ + "media/images/selectionBet__flagBg-c5460ccfb4c8e9a45b2f64ebf0d875ea.jpg";